import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "drawer-header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "pa-4" }
const _hoisted_4 = { class: "hk-appbar__inner" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "hk-nav d-none d-md-flex" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_navigation_drawer, {
      modelValue: _ctx.drawer,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.drawer) = $event)),
      temporary: "",
      location: "right",
      width: "280"
    }, {
      append: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_btn, {
            block: "",
            color: "primary",
            variant: "flat",
            "prepend-icon": "mdi-phone",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go('/connection')))
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Kapcsolat ")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.logo,
            alt: "Kreatív Hímző Kuckó",
            class: "drawer-logo"
          }, null, 8, _hoisted_2)
        ]),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_list, {
          nav: "",
          density: "comfortable"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: item.path,
                active: _ctx.isActive(item.path),
                color: "primary",
                rounded: "lg",
                title: item.title,
                onClick: ($event: any) => (_ctx.go(item.path))
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: item.icon
                  }, null, 8, ["icon"])
                ]),
                _: 2
              }, 1032, ["active", "title", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_app_bar, {
      flat: "",
      elevation: _ctx.scrolled ? 4 : 0,
      color: _ctx.scrolled ? 'surface' : 'transparent',
      class: _normalizeClass(['hk-appbar', { 'hk-appbar--scrolled': _ctx.scrolled }]),
      height: "76"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "hk-brand",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go('/'))),
            "aria-label": "Főoldal"
          }, [
            _createElementVNode("img", {
              src: _ctx.logo,
              alt: "Kreatív Hímző Kuckó",
              class: "hk-brand__logo"
            }, null, 8, _hoisted_5)
          ]),
          _createVNode(_component_v_spacer),
          _createElementVNode("nav", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                key: item.path,
                class: _normalizeClass(["hk-nav__link", { 'hk-nav__link--active': _ctx.isActive(item.path) }]),
                onClick: ($event: any) => (_ctx.go(item.path))
              }, _toDisplayString(item.title), 11, _hoisted_7))
            }), 128)),
            _createVNode(_component_v_btn, {
              class: "ms-3",
              color: "primary",
              variant: "flat",
              "prepend-icon": "mdi-phone",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.go('/connection')))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode(" Ajánlatkérés ")
              ])),
              _: 1
            })
          ]),
          _createVNode(_component_v_app_bar_nav_icon, {
            class: "d-flex d-md-none",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.drawer = !_ctx.drawer))
          })
        ])
      ]),
      _: 1
    }, 8, ["elevation", "color", "class"])
  ], 64))
}